/* CTS Broadcast-inspired Dawn extension. No external dependencies. */
(() => {
  if (window.__CTS_PORTABLE_SCRIPT_READY__) return;
  window.__CTS_PORTABLE_SCRIPT_READY__ = true;
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initHero = root => {
    if (root.dataset.ctsReady) return;
    root.dataset.ctsReady = 'true';
    const panels = Array.from(root.querySelectorAll('[data-cts-slide]'));
    if (!panels.length) return;
    const dots = Array.from(root.querySelectorAll('[data-cts-dot]'));
    const prev = root.querySelector('[data-cts-prev]');
    const next = root.querySelector('[data-cts-next]');
    let current = Math.max(0, panels.findIndex(el => !el.hidden));
    let timer = null;
    const show = (index) => {
      current = (index + panels.length) % panels.length;
      panels.forEach((el, i) => {
        const active = i === current;
        el.hidden = !active;
        el.setAttribute('aria-hidden', String(!active));
        el.querySelectorAll('video').forEach(video => {
          if (active) {
            const p = video.play();
            if (p && typeof p.catch === 'function') p.catch(() => {});
          } else video.pause();
        });
      });
      dots.forEach((dot, i) => { dot.setAttribute('aria-current', i === current ? 'true' : 'false'); dot.tabIndex = i === current ? 0 : -1; });
    };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      const seconds = Number(root.dataset.autoplay || 0);
      if (panels.length > 1 && seconds >= 3 && !reduceMotion() && !document.hidden) timer = setInterval(() => show(current + 1), seconds * 1000);
    };
    prev?.addEventListener('click', () => { show(current - 1); start(); });
    next?.addEventListener('click', () => { show(current + 1); start(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', e => { if (!root.contains(e.relatedTarget)) start(); });
    let startX = null;
    root.addEventListener('touchstart', e => { startX = e.changedTouches?.[0]?.screenX || null; }, { passive: true });
    root.addEventListener('touchend', e => {
      if (startX === null) return;
      const dx = (e.changedTouches?.[0]?.screenX || startX) - startX;
      if (Math.abs(dx) > 55) { show(current + (dx > 0 ? -1 : 1)); start(); }
      startX = null;
    }, { passive: true });
    show(current);
    start();
    root.ctsCleanup = stop;
  };
  const initScroller = root => {
    if (root.dataset.ctsReady) return;
    root.dataset.ctsReady = 'true';
    const scroll = root.querySelector('[data-cts-scroll]');
    const prev = root.querySelector('[data-cts-scroll-prev]');
    const next = root.querySelector('[data-cts-scroll-next]');
    if (!scroll) return;
    const shift = dir => scroll.scrollBy({ left: (scroll.querySelector(':scope > *')?.getBoundingClientRect().width || 280) * dir + 16 * dir, behavior: reduceMotion() ? 'instant' : 'smooth' });
    prev?.addEventListener('click', () => shift(-1));
    next?.addEventListener('click', () => shift(1));
  };
  const initTabs = root => {
    if (root.dataset.ctsTabsReady) return;
    root.dataset.ctsTabsReady = 'true';
    const tabs = Array.from(root.querySelectorAll('[data-cts-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-cts-panel]'));
    if (!tabs.length || !panels.length) return;
    const choose = index => {
      tabs.forEach((t, i) => { t.setAttribute('aria-selected', String(index === i)); t.tabIndex = index === i ? 0 : -1; });
      panels.forEach((p, i) => { p.hidden = index !== i; });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => choose(i));
      t.addEventListener('keydown', e => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault();
        const target = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        choose(target); tabs[target].focus();
      });
    });
    choose(0);
  };

  const initQuickAdd = root => {
    const forms = [];
    if (root.matches?.('form[data-cts-quick-add]')) forms.push(root);
    root.querySelectorAll?.('form[data-cts-quick-add]').forEach(form => forms.push(form));
    forms.forEach(form => {
      if (form.dataset.ctsQuickAddReady) return;
      form.dataset.ctsQuickAddReady = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const status = form.querySelector('[data-cts-quick-add-status]');
        if (!button || button.disabled) return;
        const originalText = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'ADDING...';
        if (status) { status.textContent = ''; status.dataset.state = ''; }
        const drawer = document.querySelector('cart-drawer');
        const notification = document.querySelector('cart-notification');
        const sectionIds = (drawer && typeof drawer.renderContents === 'function')
          ? ['cart-drawer', 'cart-icon-bubble']
          : (notification && typeof notification.renderContents === 'function')
            ? ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble']
            : ['cart-icon-bubble'];
        const formData = new FormData(form);
        if (sectionIds.length && (drawer?.renderContents || notification?.renderContents)) {
          formData.set('sections', sectionIds.join(','));
          formData.set('sections_url', window.location.pathname);
        }
        try {
          const response = await fetch(form.action, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(state.description || state.message || 'Unable to add this item.');
          if (drawer && state.sections?.['cart-drawer'] && typeof drawer.renderContents === 'function') {
            drawer.renderContents(state);
          } else if (notification && state.sections?.['cart-notification-product'] && typeof notification.renderContents === 'function') {
            notification.renderContents(state);
          } else {
            document.dispatchEvent(new CustomEvent('cts:cart:updated', { detail: state }));
            const root = window.Shopify?.routes?.root || '/';
            window.location.assign(root.replace(/\/?$/, '/') + 'cart');
            return;
          }
          button.textContent = 'ADDED';
          if (status) { status.textContent = 'Added to your bag.'; status.dataset.state = 'success'; }
          window.setTimeout(() => { button.textContent = originalText; }, 1600);
        } catch (error) {
          if (status) { status.textContent = error.message || 'Unable to add this item. Please try again.'; status.dataset.state = 'error'; }
          button.textContent = originalText;
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    });
  };

  const initialize = target => {
    const roots = [target, ...target.querySelectorAll('[data-cts-hero], [data-cts-scroller], [data-cts-tabs]')];
    roots.forEach(root => {
      if (root.matches?.('[data-cts-hero]')) initHero(root);
      if (root.matches?.('[data-cts-scroller]')) initScroller(root);
      if (root.matches?.('[data-cts-tabs]')) initTabs(root);
    });
    initQuickAdd(target);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', e => initialize(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-cts-hero]').forEach(root => root.ctsCleanup?.()));
})();
